import { defineVizView } from "@/lib/ai/visualization/views/shared/view-definition";
import {
  buildTimeSeriesLineElement,
  compileTimeSeriesLineSpec,
  validateTimeSeriesLineSpec,
} from "@/lib/ai/visualization/views/time-series-line/logic";
import { timeSeriesLineAuthoringSchema } from "@/lib/ai/visualization/views/time-series-line/schema";

/**
 * `time-series-line` definition の SSOT エントリ。
 */
export const timeSeriesLineDefinition = defineVizView({
  type: "time-series-line",
  componentType: "TimeSeriesLine",
  authoringSchema: timeSeriesLineAuthoringSchema,
  authoringPrompt: {
    summary:
      "Wide time-series with one or more metric keys on a shared chronological x-axis.",
    requiredKeys: ["xKey", "xLabel", "seriesKeys", "seriesLabelEntries"],
    optionalKeys: [],
    selectionRules: [
      "seriesKeys must contain at least one metric key.",
      "Always provide xLabel in task.outputLanguage.",
      "Always provide seriesLabelEntries using selected metric keys only, and cover every selected metric key.",
      "When dataset queryContext requests moving averages and matching fields share the same metricFamily, include the requested 7d/28d moving-average series with the corresponding raw line series.",
    ],
    avoidWhen: [
      "Audit/detail inspection where exact rows matter more than trend shape.",
      "Grouped breakdown trends that need per-group lines from long-form rows.",
      "Dense category snapshots that should be ranked rather than plotted over time.",
    ],
    minimalExamples: [
      {
        label: "single-metric-trend",
        view: {
          type: "time-series-line",
          xKey: "date",
          xLabel: "Date",
          seriesKeys: ["clicks"],
          seriesLabelEntries: [{ key: "clicks", label: "Clicks" }],
        },
      },
    ],
  },
  datasetRequirements: {
    requiresTimeDimension: true,
    requiresCategoryDimension: false,
    minMetricCount: 1,
    requiresCompareMode: false,
  },
  validateSpec: validateTimeSeriesLineSpec,
  buildElement: buildTimeSeriesLineElement,
  compileSpec: compileTimeSeriesLineSpec,
});
